module.exports = __webpack_public_path__ + "img/book-005.291b9d90.jpg";